var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKenya(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4029_4133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.6895C18.6274 24.6895 24 19.3169 24 12.6895C24 6.06204 18.6274 0.689453 12 0.689453C5.37258 0.689453 0 6.06204 0 12.6895C0 19.3169 5.37258 24.6895 12 24.6895Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0.689453C7.24242 0.689453 3.13167 3.45813 1.19067 7.47208H22.8092C20.8682 3.45813 16.7574 0.689453 12 0.689453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24.6894C7.24242 24.6894 3.13167 21.9207 1.19067 17.9067H22.8092C20.8682 21.9207 16.7574 24.6894 12 24.6894Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4333 9.03735H0.566672C0.199078 10.189 0 11.416 0 12.6895C0 13.9631 0.199078 15.19 0.566672 16.3417H23.4333C23.8009 15.19 24 13.9631 24 12.6895C24 11.416 23.8009 10.189 23.4333 9.03735Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7367 6.23478L14.3156 5.57886L12.0001 10.8219L9.68454 5.57886L8.26343 6.23478L11.1382 12.6894L8.26343 19.1441L9.68454 19.8L12.0001 14.557L14.3156 19.8L15.7367 19.1441L12.862 12.6894L15.7367 6.23478Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9653 6.85291C12.4152 6.25211 12.0001 5.90674 12.0001 5.90674C12.0001 5.90674 11.585 6.25207 11.0349 6.85291V18.5257C11.585 19.1266 12.0001 19.472 12.0001 19.472C12.0001 19.472 12.4152 19.1267 12.9653 18.5258V6.85291Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39136 9.09135V16.2872C9.9727 17.3173 10.6842 18.1616 11.2175 18.7214V6.65723C10.6842 7.21696 9.97265 8.06132 9.39136 9.09135Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6088 9.09135C14.0274 8.06127 13.316 7.21696 12.7827 6.65723V18.7214C13.3159 18.1616 14.0274 17.3173 14.6088 16.2872V9.09135Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6086 9.09155V16.2874C15.1972 15.2445 15.6521 14.0113 15.6521 12.6895C15.6521 11.3678 15.1972 10.1345 14.6086 9.09155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39139 9.09155V16.2874C8.80287 15.2445 8.3479 14.0113 8.3479 12.6895C8.3479 11.3678 8.80287 10.1345 9.39139 9.09155Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4029_4133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.689453)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKenya);
export default __webpack_public_path__ + "static/media/kenya.71878077767534096b4ae64a534adebc.svg";
export { ForwardRef as ReactComponent };